module.exports = __webpack_public_path__ + "img/143.322505d7.jpg";